import { Id } from './types';

const compareStrings = (id: Id, value: Id) => String(id) === String(value);
const findName = (arr: Array<any>, value: Id) =>
  arr.find(({ id }) => compareStrings(id, value));

export default findName;



// WEBPACK FOOTER //
// ./src/services/financigservice/utils/findName.ts